export const downloadPdf = async (
  pdfData: string,
  customName: string,
): Promise<boolean> => {
  const isChrome = navigator.userAgent.toLowerCase().indexOf('CriOS') > -1;

  let iOSVersion: number[] = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
  if (iOS) {
    const matchResult = navigator.userAgent.match(/OS [\d_]+/i);
    iOSVersion = matchResult ? matchResult[0]
      .substring(3)
      .split('_')
      .map((n) => parseInt(n, 10)) : [];
  }

  const linkElement = document.createElement('a');

  try {
    let contentType = 'application/pdf';
    let blob;

    if (iOS && !isChrome && iOSVersion[0] <= 12) {
      blob = new Blob([pdfData], { type: contentType });
    } else {
      if (iOS && !isChrome) {
        contentType = 'application/octet-stream';
      }
      blob = new Blob([pdfData], { type: contentType });
    }

    const hrefUrl = window.URL.createObjectURL(blob);
    linkElement.setAttribute('href', hrefUrl);
    linkElement.setAttribute('target', '_blank');

    if ((iOS && (iOSVersion[0] > 12 || isChrome)) || !iOS) {
      linkElement.setAttribute('download', customName);
    }

    const clickEvent = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: false,
    });

    linkElement.dispatchEvent(clickEvent);

    return true;
  } catch (ex) {
    return false;
  }
};

export const printPdfDocument = async (src: string): Promise<void | undefined> => {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  document.body.appendChild(iframe);
  iframe.src = src;
  // eslint-disable-next-line consistent-return
  return new Promise((resolve) => {
    iframe.onload = () => {
      setTimeout(() => {
        try {
          // eslint-disable-next-line no-unused-expressions
          iframe.contentWindow?.focus();
          resolve();
          // eslint-disable-next-line no-unused-expressions
          iframe.contentWindow?.print();
          return true;
        } catch (er) {
          return false;
        }
      }, 0);
    };
  });
};
